import { Navigate } from 'react-router-dom';

import {
  shouldRedirectTenantToDashboard,
  TENANT_ADMIN_HOME,
  TENANT_LOGIN_HOME,
} from '../../config/tenantMode';

export function TenantHomeRedirect() {
  return (
    <Navigate
      to={shouldRedirectTenantToDashboard() ? TENANT_ADMIN_HOME : TENANT_LOGIN_HOME}
      replace
    />
  );
}
